import {Component, Input, OnInit, HostBinding} from '@angular/core';
import 'rxjs/Rx';
import {FormControl } from '@angular/forms';
import { ValidationService } from '../../../shared/services/validation.service';

@Component({
  selector: 'form-message',
  templateUrl: 'message.component.html'
})
export class FormMessageComponent implements OnInit{
  @HostBinding('class.form-error') formMessageClass = true;
  @Input() control: FormControl;
  @Input() subControl?: FormControl;
  @Input() form: any; // FormControl;
  @Input() label: string;

  constructor() {
  }

  public errorMessage(control) {
    // console.log("errorMessage");
    for (let propertyName in control.errors) {
      if (control.errors.hasOwnProperty(propertyName)) {
        return ValidationService.getValidatorErrorMessage(propertyName, this.label);
      }
    }
    return null;
  }


  ngOnInit() {
   // console.log(this.model);
  }

}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/components/form/message/message.component.ts